export default "/images/277b8663c835a5a0597c7c329187a900.avif";